import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import i18n from 'i18next';
import Logout from 'client/components/Logout';
import useClientHistory, { RESULT } from 'client/hooks/useClientHistory';
import { joinRegex } from 'client/hooks/useInitPromo/useInitPromo';
import { isDoNotShowCheckRecordsBtnGames } from 'config/promoGameTypesClientConfig';
import Button from '@material-ui/core/Button';
import { setTextVariantStyle } from 'utils/variantStyle';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { gameTypes } from 'config/promoGameTypes';
import ViewRecordsBtn from 'editor/game_checkIn/components/ViewRecordsBtn';
import EntriesList from './Result/EntriesInfo/EntriesList';
import usePromoSettingComponentStyle from 'hooks/usePromoSettingComponentStyle';

const FooterActionButton = () => {
    const gameType = useSelector(s => s.promo.type);
    const promoId = useSelector(s => s.promo.id);
    const themeStyle = usePromoSettingThemeStyle();
    const history = useClientHistory();
    const { enableCoverPage } = useSelector(s => s.settingPromo);
    const { isCoverPagePhase } = useSelector(s => s.userEntryState);
    const isJoinPage = Boolean(window.location?.pathname?.match(joinRegex));
    const promoType = useSelector(s => s.promo.type);
    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const isGameReadyToPlay = useSelector(s => s.purePrizeState.isGameReadyToPlay);
    const componentStyle = usePromoSettingComponentStyle();

    function handleCheckRecord() {
        history.push(RESULT);
    }
    const isCoverPage = enableCoverPage && isCoverPagePhase && isJoinPage;
    // 使用useMemo記憶化shouldHideRecordBtn的計算結果
    const shouldHideJoinPageRecordBtn = useMemo(() => {
        if (!isJoinPage) {
            return true;
        }
        if (isDoNotShowCheckRecordsBtnGames(gameType)) {
            return true;
        }
        if (userGameResultRecords.length === 0) {
            return true;
        }
        if (promoType === gameTypes.RED_ENVELOPE_RAIN && isGameReadyToPlay) {
            return true;
        }
        return false;
    }, [isJoinPage, gameType, userGameResultRecords.length, promoType, isGameReadyToPlay]);

    const shouldHideRecordBtn = useMemo(() => 
        //不是join page 或 參加及結果模組
        isJoinPage && !isDoNotShowCheckRecordsBtnGames(gameType)
    , [gameType, isJoinPage]);

    return (
        <div css={containerStyle}>
            <div
                css={buttonContainerStyle(
                    isCoverPage ? themeStyle.contentBgColor : 'transparent',
                    !shouldHideJoinPageRecordBtn || !shouldHideRecordBtn
                )}
            >
                {!shouldHideJoinPageRecordBtn && (
                    <Button
                        css={recordButtonStyle(themeStyle.titleColor)}
                        variant="text"
                        onClick={handleCheckRecord}
                        disableRipple={true}
                        disableFocusRipple={true}
                        disableTouchRipple={true}
                    >
                        {i18n.t('label.check_record')}
                    </Button>
                )}
                {!shouldHideRecordBtn && (
                    <ViewRecordsBtn
                        btnStyle={recordButtonStyle(themeStyle.titleColor)}
                        variant="medium"
                    >
                        <EntriesList
                            items={userGameResultRecords}
                            gameType={gameType}
                            promoId={promoId}
                            componentStyle={componentStyle}
                            needShowFormBtn
                        />
                    </ViewRecordsBtn>
                )}
                <Logout customWrapperStyle={logoutWrapperStyle} customStyle={logoutButtonStyle} />
            </div>
        </div>
    );
};

export default FooterActionButton;

const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px 0;
`;

const buttonContainerStyle = (bgColor, hasBothButtons) => css`
    display: flex;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    background-color: ${bgColor};
    padding: 8px 16px;
    ${hasBothButtons && 'gap: 32px;'}
    &:empty {
        display: none;
    }
`;

const recordButtonStyle = textColor => css`
    ${setTextVariantStyle('subtitle2')}
    cursor: pointer;
    text-align: center;
    color: ${textColor};
    padding: 0px;
    line-height: 24px;
    border: none;
    &:hover {
        background-color: transparent;
        border: none;
    }
    &:active {
        box-shadow: none;
        border: none;
    }
`;

const logoutWrapperStyle = css`
    ${setTextVariantStyle('subtitle2')}
    cursor: pointer;
    text-align: center;
`;

const logoutButtonStyle = css`
    ${setTextVariantStyle('subtitle2')}
`;
